import React, { createContext, useContext, useState } from "react";
import CustomAlert from "@/components/CustomAlert";

const AlertContext = createContext();

export function AlertProvider({ children }) {
	const [alertOptions, setAlertOptions] = useState({ show: false });

	const showAlert = ({ title, message, buttonOKText,twoButton, buttonCancelText  }) => {
		return new Promise((resolve) => {
			setAlertOptions({
				show: true,
				title,
				message,
				buttonOKText,
				twoButton, 
				buttonCancelText,
				onOK: () => {
					setAlertOptions({ show: false });
					resolve("ok"); // 닫힐 때 Promise 완료
				},
				onCancel: () => {
					setAlertOptions({ show: false });
					resolve("cancel"); // 닫힐 때 Promise 완료
				},
			});
		});
	};

	return (
		<AlertContext.Provider value={showAlert}>
			{children}
			<CustomAlert {...alertOptions} />
		</AlertContext.Provider>
	);
}

export function useAlert() {
	return useContext(AlertContext);
}
